module.exports = __webpack_public_path__ + "static/media/nav-more-white.cb1a5d57.svg";